export default __webpack_public_path__ + "static/media/dostawa2.99aea508.svg";